import { Link } from "react-router-dom";

export const CustomizeBanner = () => {
  return (
    <section
      className="flat-spacing-1 pt_0"
      style={{
        fontFamily: "Albert Sans, sans-serif",
      }}
    >
      <div className="container">
        <div className="tf-grid-layout md-col-2 tf-img-with-text style-1">
          <div className="tf-image-wrap wow fadeInUp" data-wow-delay="0s">
            <img
              className="lazyload"
              data-src="images/collection-60.jpg"
              src="images/collection-60.jpg"
              alt="collection-img"
            />
          </div>
          <div className="tf-content-wrap wow fadeInUp" data-wow-delay="0s">
            <div className="heading">
              Designed by You, <br />
              Crafted by Us
            </div>
            <p style={{ color: "#94969F" }} className="description">
              Choose your flavors, size, shape, and style — and let us bring
              your vision to life.
            </p>
            <Link to={`/customOrders`} className="title link">
              <span className="tf-btn style-2 btn-fill rounded-full animate-hover-btn">
                Customize your Favourite
              </span>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};
